import React, { Fragment, useEffect, useState } from "react";
import { useContextSelector } from "use-context-selector";
import {  isEmpty, isNumber } from "lodash";
import BetSlipContext from "../../../context/BetSlipContext";
import { formatWithCommas } from "../../../Utils/Toast";
import RenderSkyOdds from "./RenderSkyOdds";
import BetSlipSky from "./BetSlipSky";
import { useBookmakerLogic } from "../../useLogic/useBookmakerLogic";
const BookmakerSky = ({
  runner,
  backOdds,
  layOdds,
  oldBack,
  oldLay,
  profileData,
  marketName,
  detail,
  ms,
  typeGame,
  user,
  marketId,
  totalMatched,
  addToFavioute,
  position,
}) => {
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });

  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });

  const [showLimit, setShowLimit] = useState(false);
  const { localLimit, handelChange, checkArrays, fav } = useBookmakerLogic({
    backOdds,
    layOdds,
    oldBack,
    oldLay,
    profileData,
    marketName,
    detail,
    ms,
    typeGame,
    user,
    marketId,
    totalMatched,
    position,
  });
  return (
    <div id="bookMakerWrap">
      <div id="bookMakerSpecialBet" className="bets-bookmaker">
        <h4>
          <div
            onClick={(e) => {
              if (!isEmpty(detail?.bookmakerMarketId)) {
                e.preventDefault();
                e.stopPropagation();
                addToFavioute(
                  detail?.eventId,
                  "Bookmaker",
                  detail?.bookmakerMarketId,
                  detail?.eventType
                );
              }
            }}
            id="multiMarketPin"
            className={fav ? "pin-on" : "pin-off"}
          >
            Pin to Muilti Markets
          </div>
          <span>Bookmaker Market</span>
          <p>| Zero Commission</p>
        </h4>
      </div>
      <div
        id="bookMakerMarket_34719325_282755"
        className={`bets-wrap bets-bookmaker ${
          backOdds?.length == 0 && layOdds?.length == 0 ? "disabled" : ""
        } `}
        style={{ display: "block" }}
      >
        <h5>
          <span id="market-name">Bookmaker</span>
          <div
            onClick={(e) => {
              setShowLimit(true);
            }}
            id="openBookMakerInfo"
            className="btn-fancy_info"
          ></div>
          <div
            style={{ display: showLimit ? "flex" : "none" }}
            id="bookMakerMinMax"
            className="fancy_info-popup"
          >
            <dl>
              <dt>Min / Max</dt>
              <dd id="minMax">
                {formatWithCommas(localLimit?.minAmount)}/
                {formatWithCommas(localLimit?.maxAmount)}
              </dd>
            </dl>
            <dl></dl>
            <div
              onClick={() => setShowLimit(false)}
              id="closeBookMakerInfo"
              className="close"
            >
              Close
            </div>
          </div>
        </h5>
        <dl className="bets-selections-head">
          <dt />
          <dd className="mode-land" />
          <dd className="mode-land" />
          <dd>Back</dd>
          <dd>Lay</dd>
          <dd className="mode-land" />
          <dd className="mode-land" />
        </dl>
        {runner?.map((item, index) => {
          const odds_back = backOdds?.filter(
            (todd) =>
              todd?.runnerName?.toLowerCase() ==
              (item?.RunnerName?.toLowerCase() ||
                item?.runnerName?.toLowerCase())
          );
          const odds_lay = layOdds?.filter(
            (todd) =>
              todd?.runnerName?.toLowerCase() ==
              (item?.RunnerName?.toLowerCase() ||
                item?.runnerName?.toLowerCase())
          );
          const old_back = oldBack?.filter(
            (todd) =>
              todd?.runnerName?.toLowerCase() ==
              (item?.RunnerName?.toLowerCase() ||
                item?.runnerName?.toLowerCase())
          );
          const old_lay = oldLay?.filter(
            (todd) =>
              todd?.runnerName?.toLowerCase() ==
              (item?.RunnerName?.toLowerCase() ||
                item?.runnerName?.toLowerCase())
          );
          let disabelBack = "lockBackBets" in item ? item?.lockBackBets : false;
          let disabelLay = "lockLayBets" in item ? item?.lockLayBets : false;
          let disableFull = checkArrays(
            odds_back?.slice(0, 1),
            odds_lay?.slice(0, 1),
            localLimit
          );

          let showPosition =
            (isNumber(item?.position) &&
              position?.length > 0 &&
              Math.abs(item?.position) > 0) ||
            (Math.abs(item?.newPosition) >= 0 &&
              showBetDialog &&
              betSlipObject?.playType == typeGame &&
              detail?.marketId == betSlipObject?.object?.newMarketId);

          return (
            <React.Fragment>
              <dl
                id="bookMakerSelection_34719325_282755_832862"
                className="bets-selections"
                style={{ display: "flex" }}
              >
                <dt>
                  <h4 id="runnerName">
                    {" "}
                    {item?.RunnerName || item?.runnerName}
                  </h4>
                  {showPosition && (
                    <ul id="winLoss">
                      {isNumber(item?.position) &&
                        position?.length > 0 &&
                        Math.abs(item?.position) > 0 && (
                          <li
                            id="withoutBet"
                            className={item?.position > 0 ? "win" : "lose"}
                          >
                            {isNumber(item?.position) &&
                            Math.abs(item?.position) > 0
                              ? item?.position > 0
                                ? Math?.abs(item?.position).toFixed(2)
                                : `(${Math.abs(item?.position).toFixed(2)})`
                              : ""}
                          </li>
                        )}
                      {Math.abs(item?.newPosition) >= 0 &&
                        showBetDialog &&
                        betSlipObject?.playType == typeGame &&
                        marketId == betSlipObject?.object?.newMarketId && (
                          <li
                            id="withBet"
                            className={`to-${
                              item?.newPosition > 0 ? "win" : "lose"
                            }`}
                          >
                            {item?.newPosition > 0
                              ? Math.abs(item?.newPosition).toFixed(2)
                              : `(${Math.abs(item?.newPosition).toFixed(2)})`}
                          </li>
                        )}
                    </ul>
                  )}
                </dt>

                <RenderSkyOdds
                  component={typeGame}
                  index={index}
                  marketName={marketName}
                  item={item}
                  disabelBack={disabelBack}
                  oldBack={old_back}
                  oldLay={old_lay}
                  disableFull={disableFull}
                  disabelLay={detail?.market == "Win" ? true : disabelLay}
                  isInPlay={
                    ["Win", "Winner"].includes(detail?.market)
                      ? true
                      : detail?.status == "in_play"
                      ? true
                      : false
                  }
                  handelChange={handelChange}
                  odds_lay={odds_lay}
                  odds_back={odds_back}
                  limit={localLimit}
                  ms={ms}
                  betType={betSlipObject?.betType}
                  active={
                    showBetDialog &&
                    marketId == betSlipObject?.newMarketId &&
                    item?.SelectionId == betSlipObject?.object?.SelectionId &&
                    "bookmaker" == betSlipObject?.playType
                  }
                />
              </dl>
              {showBetDialog &&
                betSlipObject?.playType == "bookmaker" &&
                marketId == betSlipObject?.object?.newMarketId &&
                betSlipObject?.object?.SelectionId == item?.SelectionId && (
                  <BetSlipSky />
                )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};

export default BookmakerSky;
